import { useCallback } from 'react';
import { reportEvent } from '@/app/utils';
import { usePathname } from '@/i18n/routing';
import { useStore } from '../providers/store';
import { useGlobalModal } from './use-global-modal';

export const useLoginRequired = () => {
  const userInfo = useStore((state) => state.userInfo);
  const pathname = usePathname();
  const { open: openLoginDialog } = useGlobalModal('loginDialog');

  /**
   * 检查登录状态，如果未登录，则执行额外操作
   * @param options 配置选项
   * @param options.onNeedLogin 未登录时需要执行的回调,默认跳转到登录页
   * @returns
   */
  const checkLoginAndExecute = useCallback(
    (options?: { onNeedLogin?: () => void; targetUrl?: string }) => {
      if (!userInfo) {
        options?.onNeedLogin?.();
        openLoginDialog({
          redirectUrl: options?.targetUrl ?? pathname + location.search,
        });
        reportEvent('login_pop_exposure', {
          refer_element: 'login-required',
          refer_page: pathname,
        });
      }
    },
    [openLoginDialog, pathname, userInfo],
  );

  return { checkLoginAndExecute, isLoggedIn: !!userInfo };
};
